import type {
  IContextMutationResult,
} from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import {
  useContextMutation,
} from '@modules/core/services/query';

import type {
  ITableFilterPresetNewPayload,
  ITableFilterResponse,
} from '../types';
import {
  TABLE_FILTER_SETS_URL,
  TABLE_NEW_FILTER_SETS_MUTATION_KEY,
  TABLES_PERMISSIONS,
} from '../constants';

export default function useTableFilterPresetMutation(): IContextMutationResult<ITableFilterResponse, Error, ITableFilterPresetNewPayload> {
  const { fetchPost } = useRestClient();

  return useContextMutation<ITableFilterResponse, Error, ITableFilterPresetNewPayload>({
    mutationKey: [TABLE_NEW_FILTER_SETS_MUTATION_KEY],
    mutationFn: (payload) => {
      const { filterName, ...body } = payload;

      return fetchPost(TABLE_FILTER_SETS_URL, body, {
        permission: TABLES_PERMISSIONS.FILTERSETS_SHOW,
        urlParams: {
          filterName,
        },
      });
    },
  });
}
